  
  <!-- Alert -->
  <div class="modal fade show" [class.d-block]="showAlert" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{alertMessage | translate | htmlToText}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="showAlert = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>


  <!-- Alert carrello configuratore -->
  <div class="modal fade show" [class.d-block]="showAlertCarrelloConfiguratore" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{alertMessage | translate | htmlToText}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="showAlertCarrelloConfiguratore = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body px-0 pt-0">
          <div class="col-12">
            <a appHref="/configuratore">
              <button class="btn btn-stem mx-auto" type="button">
                {{'TESTO_BOTTONE_CONFIGURATORE_CARRELLO' | translate | htmlToText}}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  